exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grouping-box {\n  display: flex;\n  flex-direction: row;\n  margin: 0 8px;\n}\n\n.grouping-box .group-by-label {\n  display: flex;\n  margin-right: 10px;\n}\n\nmdl-radio {\n  display: flex;\n  margin-right: 10px;\n}\n\n", ""]);

// exports
